// extracted by mini-css-extract-plugin
export default {"nav":"FMZX9box4KBDsvSwydPq","placeHolderShimmer":"R4dmGjU8yCXkrItk9HC8"};